// @flow

import type { Merchant } from './types';

export function getThemeId(merchant: Merchant): string {
  return merchant.theme;
}
